import mixins from 'vue-typed-mixins';

import { E勘定科目カテゴリ } from '@/openapi/enum';
import { 勘定科目Api, 勘定科目ListItemResponse, 勘定科目Request } from '@/openapi/user';

import UserApiUtility from '@/classes/common/UserApiUtility';
import 事業所Mixin from '@/entries/user/mixins/事業所Mixin';
import AlertMixin from '@/mixins/AlertMixin';

export default mixins(AlertMixin, 事業所Mixin).extend({
  name: 'M勘定科目SaveMixin',

  methods: {
    async save勘定科目ByMixin(
      isNew: boolean,
      cカテゴリ: E勘定科目カテゴリ,
      edit勘定科目: 勘定科目ListItemResponse
    ): Promise<boolean> {
      const { pk, ...picked勘定科目 } = edit勘定科目;
      const request: 勘定科目Request = {
        ...picked勘定科目,
        cカテゴリ,
      };

      const api = UserApiUtility.ogApi(勘定科目Api);
      const response = isNew
        ? await api.create勘定科目(this.事業所.pk, request)
        : await api.update勘定科目(pk, request);

      return this.isValidationErrorResponse(response);
    },
  },
});
